import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WarehouseRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("location");
